/* ------------------------------------------ Global Object ------------------------------ */
if (typeof g === "undefined") {
	var g = new Object();
  g.cb                  = "";
  g.csrfToken           = "";
  g.domainName          = "";
  g.corporateDomainName = "";
  g.googleMapsApiKey    = "";
  g.view                = "";

	sessionStorage.setItem("apiKey", $.cookie('APIKEY') );
	sessionStorage.setItem("apiToken", $.cookie('APITOKEN') );

}

g.hostname = window.location.hostname;